.planne-widget.planne-widget-checkout {
 .planne-widget-checkout-cart-display {
  overflow: hidden;
  margin: 20px auto;
  border: 1px solid #aaa;
  max-width: 800px;
  padding: 10px;
  background-color: #fff;
  color: #444;
  border-radius: 10px;

  .planne-widget-checkout-pending-sales {
      & > div {
          margin-bottom: 5px;
          border: 1px solid #eea236;
          padding: 10px;
          background-color: #f9c987;
          border-radius: 10px;

          a {
              display: block;
          }
      }
  }

  .planne-widget-checkout-cart-items-holder {
      display: table;
      width: 100%;
      border-collapse: collapse;

      .planne-widget-checkout-cart-row {
          display: table-row;
          padding: 20px 10px;
          border-bottom: 1px solid #ddd;

          &:last-child {
              border-bottom: none;
          }

          &.planne-widget-checkout-cart-item {
              font-size: 13px;
          }

          .planne-widget-checkout-cart-col {
              display: table-cell;
              padding: 15px 10px;
          }

          .planne-widget-checkout-resources {
              margin-top: 1rem;

              small {
                  margin-left: 5px;
              }
          }
      }

      .planne-widget-checkout-additionals-title {
          margin-top: 5px;
      }

      .planne-widget-checkout-remove-item-label {
          display: none;
          margin-left: 5px;
      }
  }

  .planne-widget-checkout-empty-cart-notice {
      padding: 40px 0;
      font-weight: bold;
      text-align: center;
  }

  .planne-widget-checkout-thumbnail {
      margin-right: 5px;
      width: 48px;
      height: 48px;
      border-radius: 100%;
      vertical-align: middle;
  }

  .planne-widget-checkout-description {
      strong {
          display: block;
      }
  }

  .planne-widget-checkout-featured-label {
      text-align: right;
  }


  .planne-widget-checkout-cart-item-actions {
      font-size: 12px;
  }

  .planne-widget-checkout-cart-validation {
      line-height: 1.4rem;
      font-weight: bold;
      color: #ea4335;
  }

  .planne-widget-checkout-cart-add-coupon {
      & > div {
          margin: 2px;
      }

      input {
          border: 1px solid #949494;
          border-radius: 5px;
          padding: 5px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
      }

      input + .planne-button {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
      }
  }

  .planne-widget-checkout-cart-actions {
      margin-top: 10px;
      text-align: right;

      .planne-border-button {
          margin-right: 10px;
      }
  }

  @media (max-width: 500px) {
      .planne-widget-checkout-cart-items-holder {
          display: block;

          .planne-widget-checkout-cart-row {
              display: block;

              &.planne-widget-checkout-cart-row-header {
                  display: none;
              }

              .planne-widget-checkout-cart-col {
                  display: block;
              }
          }

          .planne-widget-checkout-cart-value {
              .planne-widget-checkout-cart-value-col {
                  display: inline-block;
              }
              .planne-widget-checkout-cart-empty-col {
                  display: none;
              }
          }
      }

      .planne-widget-checkout-cart-actions {
          display: flex;
          flex-direction: column;

          & > button {
              flex: 1;

              &.planne-border-button {
                  order: 2;
                  margin: 15px 0 0;
              }
          }
      }
  }
 }
}
